import { collections } from "@/mocks/comics";

export default function Collections() {
  return (
    <section id="collection" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-medium text-accent-900">
              <i className="ri-stack-fill text-accent-600"></i>
              精选合集
            </span>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
              海量合集，一次追个够
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              按题材与主题聚合整理的漫画合集，经典爆款与口碑佳作一网打尽，省去翻找的烦恼。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((col) => (
            <a
              key={col.id}
              href="#collection"
              className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-100"
            >
              <div className="relative h-44 overflow-hidden md:h-48">
                <img
                  src={col.image}
                  alt={`${col.title} 合集封面`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <span className="absolute left-3 top-3 rounded bg-background-50/90 px-2 py-0.5 text-xs font-semibold text-primary-600">
                  {col.tag}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-semibold text-background-50">{col.count}</span>
                    <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-background-50/90 text-primary-600 transition-transform group-hover:translate-x-1">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-950">{col.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}